module.exports = __webpack_public_path__ + "img/icon-grid-blue.76d660ba.svg";